<div class="loginBody">
  <div class="loginBody-content">
    <h1 class="loginTitle">
      {{ 'MODULES.LOGIN.SIGNIN_HEADER' | transloco }}
    </h1>
    <h2 class="loginHeader">
      {{ 'MODULES.LOGIN.SIGNUP_SUBHEADER' | transloco }}
    </h2>
    <div class="vjLoggedIn">
      <div class="vjLoggedIn_profile">
          <figure class="dsProfile dsProfile-T1">
              <!-- <img class="dsProfile_img" src="src/resources/images/avatar.svg " alt="Profile Image" /> -->
              <span>T1</span>
          </figure>
          <div>
              <p>{{ 'MODULES.LOGIN.LOGGED_IN_AS' | transloco }}</p>
              <h4 class="vjLoggedIn_profile_name">Tier 1</h4>
          </div>
      </div>
      <div class="vjLoggedIn_signout">
          <p>
              {{ 'MODULES.LOGIN.NOT_YOU' | transloco }}
              <a class="dsLink"><span class="dsLink_line">{{ 'MODULES.LOGIN.SIGN_OUT' | transloco }}</span></a>
          </p>
      </div>
  </div>
    <div class="dsFormDefault signUpForm">
      <div class="dsFieldWrap">
        <label class="dsLabel">{{ 'MODULES.LOGIN.FIRST_NAME' | transloco }}<sup class="dsAsterix">*</sup></label>
        <mat-form-field>
          <input matInput />
        </mat-form-field>
      </div>
      <div class="dsFieldWrap">
        <label class="dsLabel">{{ 'MODULES.LOGIN.LAST_NAME' | transloco }}<sup class="dsAsterix">*</sup></label>
        <mat-form-field>
          <input matInput />
        </mat-form-field>
      </div>
      <div class="dsFieldWrap dsDatePicker">
        <label class="dsLabel">{{ 'MODULES.LOGIN.DATE_OF_BIRTH' | transloco }}<sup class="dsAsterix">*</sup></label>
        <mat-form-field>
          <input matInput [matDatepicker]="dob" placeholder="dd/mm/yyyy" />
          <mat-datepicker-toggle matIconSuffix [for]="dob"></mat-datepicker-toggle>
          <mat-datepicker #dob></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="dsFieldWrap">
        <label class="dsLabel">{{ 'MODULES.LOGIN.GENDER' | transloco }}<sup class="dsAsterix">*</sup></label>
        <mat-form-field>
          <mat-select>
            <mat-option>Option 1</mat-option>
            <mat-option>Option 2</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="dsFieldWrap fullColumn">
        <label class="dsLabel">{{ 'MODULES.LOGIN.MOBILE_NUMBER' | transloco }}<sup class="dsAsterix">*</sup></label>
        <mat-form-field>
          <input matInput />
        </mat-form-field>
      </div>
    </div>
    <h2 class="vjFormTitle">{{ 'MODULES.LOGIN.ADDRESS_INFORMATION' | transloco }}</h2>
    <div class="dsFormDefault">
      <div class="dsFieldWrap">
        <label class="dsLabel">{{ 'MODULES.LOGIN.SET_FOUR_DIGIT_PIN' | transloco }}<sup class="dsAsterix">*</sup></label>
        <mat-form-field>
          <input matInput />
        </mat-form-field>
      </div>
      <div class="dsFieldWrap">
        <label class="dsLabel">{{ 'MODULES.LOGIN.CONFIRM_FOUR_DIGIT_PIN' | transloco }}<sup class="dsAsterix">*</sup></label>
        <mat-form-field>
          <input matInput />
        </mat-form-field>
      </div>
      <div class="dsFieldWrap fullColumn">
        <label class="dsLabel">{{ 'MODULES.LOGIN.ADDRESS_LINE1' | transloco }}<sup class="dsAsterix">*</sup></label>
        <mat-form-field>
          <input matInput />
        </mat-form-field>
      </div>
      <div class="dsFieldWrap fullColumn">
        <label class="dsLabel">{{ 'MODULES.LOGIN.ADDRESS_LINE2' | transloco }}<sup class="dsAsterix">*</sup></label>
        <mat-form-field>
          <input matInput />
        </mat-form-field>
      </div>
      <div class="dsFieldWrap">
        <label class="dsLabel">{{ 'MODULES.LOGIN.CITY' | transloco }}<sup class="dsAsterix">*</sup></label>
        <mat-form-field>
          <input matInput />
        </mat-form-field>
      </div>
      <div class="dsFieldWrap">
        <label class="dsLabel">{{ 'MODULES.LOGIN.STATE' | transloco }}<sup class="dsAsterix">*</sup></label>
        <mat-form-field>
          <mat-select>
            <mat-option>Option 1</mat-option>
            <mat-option>Option 2</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="dsFieldWrap">
        <label class="dsLabel">{{ 'MODULES.LOGIN.COUNTRY' | transloco }}<sup class="dsAsterix">*</sup></label>
        <mat-form-field>
          <mat-select>
            <mat-option>Option 1</mat-option>
            <mat-option>Option 2</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="dsFieldWrap">
        <label class="dsLabel">{{ 'MODULES.LOGIN.ZIP' | transloco }}<sup class="dsAsterix">*</sup></label>
        <mat-form-field>
          <input matInput />
        </mat-form-field>
      </div>
    </div>
    <h2 class="vjFormTitle">{{ 'MODULES.LOGIN.SECURITY_PROOF' | transloco }}</h2>
    <div class="dsFormDefault signUpForm">
      <div class="dsFieldWrap">
        <label class="dsLabel">{{ 'MODULES.LOGIN.IDENTITY_TYPE' | transloco }}<sup class="dsAsterix">*</sup></label>
        <mat-form-field>
          <mat-select>
            <mat-option>Option 1</mat-option>
            <mat-option>Option 2</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="dsFieldWrap">
        <label class="dsLabel">{{ 'MODULES.LOGIN.IDENTITY_NUMBER' | transloco }}<sup class="dsAsterix">*</sup></label>
        <mat-form-field>
          <input matInput />
        </mat-form-field>
      </div>
      <div class="dsFieldWrap">
        <label class="dsLabel">{{ 'MODULES.LOGIN.ISSUED_STATE' | transloco }}<sup class="dsAsterix">*</sup></label>
        <mat-form-field>
          <mat-select>
            <mat-option>Option 1</mat-option>
            <mat-option>Option 2</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="dsFieldWrap dsDatePicker">
        <label class="dsLabel">{{ 'MODULES.LOGIN.ISSUED_DATE' | transloco }}<sup class="dsAsterix">*</sup></label>
        <mat-form-field>
          <input matInput [matDatepicker]="issuedDate" placeholder="dd/mm/yyyy" />
          <mat-datepicker-toggle matIconSuffix [for]="issuedDate"></mat-datepicker-toggle>
          <mat-datepicker #issuedDate></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="dsFieldWrap dsDatePicker">
        <label class="dsLabel">{{ 'MODULES.LOGIN.EXPIRY_DATE' | transloco }}<sup class="dsAsterix">*</sup></label>
        <mat-form-field>
          <input matInput [matDatepicker]="expiryDate" placeholder="dd/mm/yyyy" />
          <mat-datepicker-toggle matIconSuffix [for]="expiryDate"></mat-datepicker-toggle>
          <mat-datepicker #expiryDate></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
  </div>
  <footer class="loginBody-footer">
    <div class="loginAction-forgotOpt">
      <div class="dsFieldWrap">
        <mat-checkbox>{{ 'MODULES.LOGIN.ACCEPT' | transloco }} <a class="dsLink"><span class="dsLink_line">{{
              'MODULES.LOGIN.TERMS_AND_CONDITIONS' | transloco }}</span></a></mat-checkbox>
      </div>
    </div>
    <button class="loginAction_btn">{{ 'MODULES.LOGIN.SIGN_UP' | transloco }}</button>
    <div class="login-options">
      <div class="login-options-link">
        <span>{{ 'MODULES.LOGIN.ALREADY_HAVE_AN_ACCOUNT' | transloco }}</span>
        <a class="dsLink"><span class="dsLink_line">{{ 'MODULES.LOGIN.SIGN_IN' | transloco }}</span></a>
      </div>
    </div>
    <div class="login-copyright">© {{ currentYear }} Light & Wonder, Inc. and its Subsidiaries. All rights reserved
    </div>
  </footer>
</div>